import React, { useEffect, useState,  useRef } from "react";
import axiosInstance from "../../ReusableComponents/Axios";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const PRCount = (props) => {
    const chartRef = useRef();
  const [PRC, SetPRC] = useState(null);
  const [PRCG,SetPRCG] = useState();

  const GetInstituteData = async () => {
    props.GraphImg();
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetOverallParticipationAndRegistrationCount?ContestCreationId=${props.CCAT?.contestCreationId}&InstituteId=${props.SIND}&AssessmentType=${props.CCAT?.assessmentType}&SocietyId=${props.SOID || 0}`
      );

      const filtered = Object.fromEntries(
        Object.entries(res.data[0]).filter(([key]) =>
          key.endsWith(props.Grade.toString())
        )
      );

      SetPRC([filtered]);
      props.PValues([filtered]);
     setTimeout(() => {
                captureImage();
            }, 2000);
    } catch (error) {
      console.error("Error fetching School data:", error);
    }
  };

  useEffect(() => {
    if(props.Grade){
      GetInstituteData();
    }
  }, [props.CCAT, props.SelectINID, props.Grade]);

const captureImage = () => {
  if (!chartRef.current) return;

  const chart = chartRef.current;

  const chartImage = chart.toBase64Image("image/png", 1);

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 1250;
  canvas.height = 650;

  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  const img = new Image();
  img.src = chartImage;

  img.onload = () => {
    const size = 700;
    const x = (canvas.width - size) / 2;
    const y = (canvas.height - size) / 2;

    ctx.drawImage(img, x, y, size, size);

    const finalImage = canvas.toDataURL("image/png");

    SetPRCG(finalImage);
    props.GraphImg(finalImage);
  };
};

  const registered = PRC?.[0]?.[`registered${props.Grade}`] || 0;
  const participated = PRC?.[0]?.[`participated${props.Grade}`] || 0;
const notParticipated = registered - participated;
  const data = {
    labels: ["Registered", "Participated"],
    datasets: [
      {
        data: [notParticipated, participated],
        backgroundColor: ["#4bc2a2", "#347363"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
      layout: {
    padding: 80,
  },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "#fff",
        font: {
          size: 56,
        },
        formatter: (value, ctx) => {
          const dataset = ctx.chart.data.datasets[0].data;
          const total = dataset.reduce((a, b) => a + b, 0);
          const percentage = total ? ((value / total) * 100).toFixed(1) : 0;
          return `${percentage}%`;
        },
      },
    },
  };

  return (
    <div >
      <Pie data={data} options={options} ref={chartRef} style={{width:"200px",height:"200px",display:"none"}}/>

    </div>
  );
};

export default PRCount;